// GENERATED by npm run generate-graphql-operations
const GetPlaylistCurator = 'query GetPlaylistCuratorWeb($pandoraId: String!) {   entity(id: $pandoraId) {     ... on Playlist {       linkedId       author {         ... on Curator {           id           artist {             id             urlPath           }         }       }     }   } } ';
export default GetPlaylistCurator;
